/**
 * Returns an anonymous function that accepts an argument as the value of the property name to look for.
 * @param collection Array of objects collection.
 * @param name The name of property to look for.
 * @returns Function
 */
export function initializePropertyRetrieval<T = unknown>(
  collection: Array<T>,
  name: string,
) {
  return (value: string) =>
    collection.find((item: any) => item[name] === value);
}
